export const messages = {
    TV_LOADED: 'TV_LOADED',
    VIDEO_UNMUTED: 'VIDEO_UNMUTED',
    CHANNEL_CHANGED: 'CHANNEL_CHANGED',
    REMOTE_CLICKED: 'REMOTE_CLICKED',
    NAV_LINK_CLICKED: 'NAV_LINK_CLICKED',
}
